import { createAPI } from "./api/api";

const api = createAPI();

let getCurrentDataAbortController;

export const getCurrentData = (
  resetCards, getDataSubUrl, activeBlock, getFiltersParams, activeFilters, offsetCount, getCurrentOrder, setSelectCards, setPaginationData, search, getParamId
) => {

  if (getCurrentDataAbortController) {
    getCurrentDataAbortController.abort();
  }


  getCurrentDataAbortController = new AbortController();
  const signal = getCurrentDataAbortController.signal;

  const params = new URLSearchParams(search);
  const searchParams = params.get('search') ? `&search=${params.get('search')}` : '';



  resetCards();

  api.get(
    `/me/nft_card_${getDataSubUrl(activeBlock)}/params?${getFiltersParams(activeFilters)}&limit=50&offset=${offsetCount}&order=${getCurrentOrder()}${searchParams}${getParamId()}`,
    { signal }
  )
  .then((response) => {
    setSelectCards(response.data.data);
    setPaginationData(response.data.pagination_metadata);
  })
  .catch((error) => {

    if (error.name === 'AbortError') {
      console.log('Запрос был отменен');
    } else {
      console.log(error.message);
      setSelectCards([]);
      setPaginationData({});
    }
  });
}

let predictionFiltersController;

export const getFilters = (activeBlock, setFilters) => {

  if (predictionFiltersController) {
    predictionFiltersController.abort();
    predictionFiltersController = null;
  }

  predictionFiltersController = new AbortController();
  const signal = predictionFiltersController.signal;

  if (activeBlock === 'Identity') {
    api.get(`/me/list_filters/params?type=identities`, {signal})
      .then((res) => setFilters(res.data.data))
      .catch((error) => console.log(error))
  } else if (activeBlock === 'Event') {
    api.get(`/me/list_filters/params?type=events`, {signal})
      .then((res) => setFilters(res.data.data))
      .catch((error) => console.log(error))
  } else if (activeBlock === 'Trigger') {
    api.get(`/me/list_filters/params?type=triggers`, {signal})
      .then((res) => setFilters(res.data.data))
      .catch((error) => console.log(error))
  } else if (activeBlock === 'Prize') {
    api.get(`/me/list_filters/params?type=prizes`, {signal})
      .then((res) => setFilters(res.data.data))
      .catch((error) => console.log(error))
  }
}

let getEligiblesAbortController = null;

export const getEligibles = async (craftBlocks, activeBlock, setIsEligiblesLoading, setEligibles) => {
  const params = {};
  let eligibleCard = "";

  craftBlocks.forEach((block) => {
    if (block.value !== null) {
      params[block.placeholder.toLowerCase()] = block.value.id;
    }
  });

  if (activeBlock) {
    eligibleCard = activeBlock.toLowerCase();
    params.eligible_card = eligibleCard;
  }

  if (getEligiblesAbortController) {
    getEligiblesAbortController.abort();
  }

  getEligiblesAbortController = new AbortController();
  const { signal } = getEligiblesAbortController;

  try {
    setIsEligiblesLoading(true);
    const response = await api.get(`/me/eligible_matches/params`, { params, signal });
    setEligibles(response.data.data);
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request cancelled');
    } else {
      console.error(error);
    }
  } finally {
    setIsEligiblesLoading(false);
  }

  return () => getEligiblesAbortController.abort();
};
